<div *ngIf="isLoading" class="overlay-new"></div>

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'print.jobs.label' | translate }}</h2>
	<div class="service-header-buttons">
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<mat-radio-group class="print-jobs-status-filter" [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()">
	<mat-radio-button value="all">{{ 'print.jobs.filter-all' | translate }}</mat-radio-button>
	<mat-radio-button *ngFor="let status of statusOptions" [value]="status" [ngClass]="jobStatusClass(status)">
		{{ 'print.collection-jobs.job-status.' + status.toLowerCase() | translate }}
	</mat-radio-button>
</mat-radio-group>

<div class="table-wrapper">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="createdAt">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.collection-jobs.created-at' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				{{ element.createdAt | date: 'd/M/yy, HH:mm' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="printer">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.jobs.printer' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.printer }}</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'print.collection-jobs.status.label' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<span class="print-job-status-chip" [ngClass]="jobStatusClass(element.status)">
					{{ 'print.collection-jobs.job-status.' + element.status.toLowerCase() | translate }}
				</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="templateOrUrls">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'print.collection-jobs.job-detail.template-or-urls' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">{{ element.templateOrUrls }}</td>
		</ng-container>

		<ng-container matColumnDef="error">
			<th mat-header-cell *matHeaderCellDef>
				{{ 'print.collection-jobs.job-detail.error' | translate }}
			</th>
			<td mat-cell *matCellDef="let element" class="print-jobs-error" [matTooltip]="element.errorMessage" [matTooltipDisabled]="!element.errorMessage">
				{{ truncateError(element.errorMessage) }}
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500]" [pageSize]="50" showFirstLastButtons></mat-paginator>
